export default __webpack_public_path__ + "static/media/Icons_History Icon.65782bed.svg";